











































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Row from '@/components/atoms/Grid/Row.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import { treatError } from '@/utils';
import AdminService from '@/api/AdminService';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import { TransactionTableListAdmin } from '@/models/transaction';
import eventBus from '@/utils/eventBus';
import { ICustomer } from '../../../models/customer';

interface IBusiness {
  id: string;
  label?: string;
  name: string;
  city: string;
  state: string;
}

interface ICustomerOption extends ICustomer {
  label?: string;
}

@Component({
  components: {
    ContentContainer,
    Row,
    SelectorAndList,
    TextInput,
    FilledButton,
    CustomSelect,
    TextField
  }
})
export default class PendingCoinsVerifier extends Vue {
  @Prop({ required: false }) data!: TransactionTableListAdmin;
  adminService = new AdminService();
  businesses = [] as any;
  customers = [] as any;
  businessesOptions: IBusiness[] = [];
  customersOptions: ICustomerOption[] = [];
  isLoading: boolean = false;
  dataForm: any = {};

  created() {
    this._setBusinessDefault();
    this._setCustomerDefault();
  }

  async searchBusinesses(search: string) {
    try {
      const {
        data: { items }
      } = await this.adminService.getBusinessesList({
        sortField: 'business.name',
        sortOrder: 'asc',
        pagination: `&skip=0&limit=100&`,
        filters: `&searchableFields=business.name&search=${search}`
      });

      this.businessesOptions = items.map((business: Record<string, any>) => {
        return {
          label: `${business.name} (${getBusinessLocationInfo(business)})`,
          ...business
        };
      });
    } catch (e) {
      this.businessesOptions = [];
    }
  }

  async searchCustomers(search: string) {
    try {
      const { data } = await this.adminService.searchCustomers(search);

      this.customersOptions = data.items.map(({ customer }) => {
        return {
          label: `${customer.name} ${customer.lastname} (${customer.mail})`,
          ...customer
        };
      });
    } catch (e) {
      this.customersOptions = [];
      this.$notification(treatError(e));
    }
  }

  async triggerTransactionsVerification() {
    try {
      this.isLoading = true;
      const {
        status,
        data
      } = await this.adminService.triggerTransactionsVerification(
        this.dataForm
      );
      if (status === 201) {
        this.$notification(
          `Transactions Updated: ${data.updated}/${data.total}`
        );
        this.closeModal();
        this.dispatchEventVerificationsComplete();
      }
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$notification(treatError(e));
    }
  }

  private _setBusinessDefault() {
    this.businesses = [];
  }

  private _setCustomerDefault() {
    this.customers = [];
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: false,
      component: 'webhookFakeFidel'
    });
  }

  @Emit('verificationComplete')
  dispatchEventVerificationsComplete() {
    return true;
  }
}
